module.exports = __webpack_public_path__ + "static/media/1POLICY5.2a03b16d.jpg";